import AssetStateSelector from '../../../components/AssetStateSelector';
import HumanContentDialog from '../../../components/HumanContentDialog';
import LanguageRewriteWarningDialog from '../../../components/LanguageRewriteWarningDialog';
import AssetPreviewLightbox from './AssetPreviewLightbox';
import AssetPickerModal from './AssetPickerModal';
import EpisodeConfirmDialogs from './EpisodeConfirmDialogs';
import DuplicateShotModal from './DuplicateShotModal';
import InsertShotModal from './InsertShotModal';
import NormalizePromptModal from './NormalizePromptModal';
import ShareLinkModal from './ShareLinkModal';
import VoiceExtractionModal from './VoiceExtractionModal';
import VoiceSwapModal from './VoiceSwapModal';

export default function EpisodeDetailModals(props: any) {
  const {
    episode,
    id,
    t,
    toast,
    showNormalizePrompt,
    projectData,
    setShowNormalizePrompt,
    handleNormalize,
    handleResolvePronouns,
    insertAfterIndex,
    insertShotData,
    insertingShotLoading,
    setInsertAfterIndex,
    handleInsertShot,
    setInsertShotData,
    minDuration,
    maxDuration,
    maxRefTotal,
    confirmRegenerate,
    confirmRematchAssets,
    confirmDeleteResource,
    deleteShotTarget,
    deleteShotStep,
    deletingShotLoading,
    setConfirmRegenerate,
    doGeneratePrompts,
    setConfirmRematchAssets,
    handleRematchEpisodeAssets,
    setConfirmDeleteResource,
    handleDeleteResource,
    setDeleteShotTarget,
    setDeleteShotStep,
    handleDeleteShot,
    duplicateShotTarget,
    duplicatingShotLoading,
    setDuplicateShotTarget,
    handleDuplicateShot,
    humanContentDialogOpen,
    handleHumanDialogNoHuman,
    handleHumanDialogHasHuman,
    handleHumanDialogCancel,
    uploadFileInputRef,
    pendingUploadShotIdRef,
    handleUploadResource,
    pickingAssetFor,
    addingAssets,
    pickerTab,
    pickerTabs,
    pickerSearch,
    pickerSelected,
    analysisAssets,
    refreshAnalysisAssets,
    projectActiveReviews,
    shots,
    shotResources,
    getAssetRefs,
    setPickingAssetFor,
    setPickerSelected,
    setPickerSearch,
    setPickerTab,
    togglePickerAsset,
    handleAddAssetRefs,
    projectAssets,
    librarySelectedIds,
    setLibrarySelectedIds,
    handleAddLibraryAssets,
    addingVideoRef,
    shotVersions,
    selectedVideoVersions,
    ineligibleLabel,
    ineligibleTitle,
    handleAddVideoRef,
    stateSelectorData,
    setStateSelectorData,
    handleSwitchAssetRef,
    previewAsset,
    setPreviewAsset,
    shareModal,
    shareForm,
    shareLoading,
    setShareModal,
    setShareForm,
    setShareLoading,
    createShareLink,
    extractionModal,
    extractionTask,
    extractionLoading,
    applyingVoice,
    appliedVoices,
    setExtractionModal,
    handleApplyVoice,
    swapModal,
    swapTask,
    swapCharacters,
    swapLoading,
    analysisChars,
    setSwapModal,
    setSwapTask,
    setSwapCharacters,
    handleSwapVoice,
    warnShot,
    languageSkillName,
    setWarnShot,
    handleApplyLanguage,
    handleGenerateVideo,
  } = props;

  return (
    <>
      <NormalizePromptModal
        open={showNormalizePrompt}
        enableScriptNormalization={projectData?.enableScriptNormalization}
        t={t}
        onClose={() => setShowNormalizePrompt(false)}
        onNormalize={handleNormalize}
        onResolvePronouns={handleResolvePronouns}
      />

      <InsertShotModal
        insertAfterIndex={insertAfterIndex}
        insertShotData={insertShotData}
        insertingShotLoading={insertingShotLoading}
        t={t}
        onClose={() => setInsertAfterIndex(null)}
        onInsert={handleInsertShot}
        onInsertShotDataChange={setInsertShotData}
        minDuration={minDuration}
        maxDuration={maxDuration}
      />

      <DuplicateShotModal
        target={duplicateShotTarget}
        loading={duplicatingShotLoading}
        t={t}
        onClose={() => setDuplicateShotTarget(null)}
        onConfirm={handleDuplicateShot}
      />

      <EpisodeConfirmDialogs
        confirmRegenerate={confirmRegenerate}
        confirmRematchAssets={confirmRematchAssets}
        confirmDeleteResource={confirmDeleteResource}
        deleteShotTarget={deleteShotTarget}
        deleteShotStep={deleteShotStep}
        deletingShotLoading={deletingShotLoading}
        t={t}
        onCancelRegenerate={() => setConfirmRegenerate(false)}
        onConfirmRegenerate={doGeneratePrompts}
        onCancelRematchAssets={() => setConfirmRematchAssets(false)}
        onConfirmRematchAssets={() => { setConfirmRematchAssets(false); handleRematchEpisodeAssets(); }}
        onCancelDeleteResource={() => setConfirmDeleteResource(null)}
        onConfirmDeleteResource={() => { if (confirmDeleteResource) { handleDeleteResource(confirmDeleteResource.resourceId, confirmDeleteResource.shotId); setConfirmDeleteResource(null); } }}
        onCancelDeleteShot={() => { setDeleteShotTarget(null); setDeleteShotStep(1); }}
        onAdvanceDeleteShotStep={() => setDeleteShotStep(2)}
        onConfirmDeleteShot={handleDeleteShot}
      />

      <HumanContentDialog
        open={humanContentDialogOpen}
        onConfirmNoHuman={handleHumanDialogNoHuman}
        onConfirmHasHuman={handleHumanDialogHasHuman}
        onCancel={handleHumanDialogCancel}
      />

      <input
        ref={uploadFileInputRef}
        type="file"
        accept="image/jpeg,image/jpg,image/png,audio/mpeg,audio/mp3,audio/wav,.mp3,.wav,video/mp4,.mp4"
        style={{ display: 'none' }}
        onChange={(event) => {
          const file = event.target.files?.[0];
          if (file && pendingUploadShotIdRef.current) handleUploadResource(pendingUploadShotIdRef.current, file);
          event.target.value = '';
        }}
      />

      <AssetPickerModal
        open={!!pickingAssetFor}
        addingAssets={addingAssets}
        pickingAssetFor={pickingAssetFor}
        pickerTab={pickerTab}
        pickerTabs={pickerTabs}
        pickerSearch={pickerSearch}
        pickerSelected={pickerSelected}
        analysisAssets={analysisAssets}
        projectActiveReviews={projectActiveReviews}
        shots={shots}
        shotResources={shotResources}
        projectId={episode.projectId}
        maxRefTotal={maxRefTotal}
        t={t}
        getAssetRefs={getAssetRefs}
        onClose={() => { if (!addingAssets && !addingVideoRef) { setPickingAssetFor(null); setPickerSelected([]); setPickerSearch(''); setLibrarySelectedIds([]); } }}
        shotVersions={shotVersions}
        selectedVideoVersions={selectedVideoVersions}
        videoPlatform={projectData?.videoPlatform}
        addingVideoRef={addingVideoRef}
        ineligibleLabel={ineligibleLabel}
        ineligibleTitle={ineligibleTitle}
        onAddVideoRef={handleAddVideoRef}
        onTabChange={(tab) => { setPickerTab(tab); setPickerSearch(''); }}
        onSearchChange={setPickerSearch}
        onSelectedChange={setPickerSelected}
        onToggleAsset={togglePickerAsset}
        onAddAssets={handleAddAssetRefs}
        projectAssets={projectAssets}
        librarySelectedIds={librarySelectedIds}
        onLibrarySelectedChange={setLibrarySelectedIds}
        onAddLibraryAssets={handleAddLibraryAssets}
        onRefreshAssets={async () => {
          try {
            await refreshAnalysisAssets(episode.projectId);
          } catch {
            toast.error(t('pickerModal.refreshFailed'));
          }
        }}
      />

      <AssetStateSelector
        open={!!stateSelectorData}
        onClose={() => setStateSelectorData(null)}
        assetName={stateSelectorData?.assetName || ''}
        assetType={stateSelectorData?.assetType ?? null}
        projectId={episode?.projectId}
        states={stateSelectorData?.allStates || []}
        currentState={stateSelectorData?.currentState || ''}
        currentImageUrl={stateSelectorData?.currentImageUrl || ''}
        onSelect={(state, imageUrl) => {
          if (stateSelectorData) {
            handleSwitchAssetRef(stateSelectorData.shotId, stateSelectorData.imgIndex, state, imageUrl);
          }
        }}
        onRefresh={async () => {
          try {
            await refreshAnalysisAssets(episode.projectId);
          } catch {
            toast.error(t('pickerModal.refreshFailed'));
          }
        }}
      />

      <AssetPreviewLightbox asset={previewAsset} onClose={() => setPreviewAsset(null)} />

      <ShareLinkModal
        open={shareModal}
        shareForm={shareForm}
        shareLoading={shareLoading}
        t={t}
        onClose={() => setShareModal(false)}
        onShareFormChange={setShareForm}
        onGenerate={async () => {
          setShareLoading(true);
          try {
            const { code } = await createShareLink(id!, { hours: shareForm.hours, maxViews: shareForm.maxViews });
            const url = `${window.location.origin}/share/${code}`;
            await navigator.clipboard.writeText(url);
            const parts = [];
            parts.push(t('shareModal.hoursValid', { hours: shareForm.hours }));
            if (shareForm.maxViews > 0) parts.push(t('shareModal.viewsLimit', { views: shareForm.maxViews }));
            toast.success(t('shareModal.linkCopied', { details: parts.join(', ') }));
            setShareModal(false);
          } catch (error: any) {
            toast.error(error.message || t('shareModal.generateFailed'));
          } finally {
            setShareLoading(false);
          }
        }}
      />

      <VoiceExtractionModal
        open={!!extractionModal}
        extractionTask={extractionTask}
        extractionLoading={extractionLoading}
        applyingVoice={applyingVoice}
        appliedVoices={appliedVoices}
        t={t}
        onClose={() => setExtractionModal(null)}
        onApplyVoice={handleApplyVoice}
      />

      <VoiceSwapModal
        open={!!swapModal}
        swapTask={swapTask}
        swapCharacters={swapCharacters}
        swapLoading={swapLoading}
        analysisChars={analysisChars}
        t={t}
        onClose={() => setSwapModal(null)}
        onReset={() => { setSwapTask(null); setSwapCharacters([]); }}
        onToggleCharacter={(name) => setSwapCharacters((prev: string[]) => prev.includes(name) ? prev.filter(item => item !== name) : [...prev, name])}
        onSwapVoice={handleSwapVoice}
      />

      <LanguageRewriteWarningDialog
        open={!!warnShot}
        skillName={languageSkillName || t('shot.languageSkillFallback')}
        onApplyFirst={() => {
          if (warnShot) {
            handleApplyLanguage(warnShot.id);
          }
          setWarnShot(null);
        }}
        onProceedAnyway={() => {
          if (warnShot) {
            handleGenerateVideo(warnShot.id);
          }
          setWarnShot(null);
        }}
        onClose={() => setWarnShot(null)}
      />
    </>
  );
}
